import { ApplicationWrapper } from '../../application-wrapper'

export const Application = () => <ApplicationWrapper />
